<h2 mat-dialog-title class="text-lg font-bold mb-1">Datos a cargar</h2>
<mat-dialog-content>
    <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
        <table mat-table class="min-w-500 overflow-y-visible mat-elevation-z" [dataSource]="data.excelData"
            class="w-full">
            <ng-container *ngFor="let column of data.displayedColumns" [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
                <td mat-cell *matCellDef="let row" class="f-12 uppercase">{{ row[column] }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="data.displayedColumns"
                class="sticky top-0 z-10 bg-white  bg-gray-100 dark:bg-gray-900"></tr>
            <tr mat-row *matRowDef="let row; columns: data.displayedColumns;" class="border-b"></tr>
        </table>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-between px-6 pb-4">
    <button mat-button mat-dialog-close class="align-left">
        Cancelar
    </button>
    <button mat-raised-button color="primary" (click)="confirmImport()">
        Importar
    </button>
</mat-dialog-actions>